import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAccount, signOut } from "../api/auth.js";

const DESTINATIONS = [
  { route: "/", label: "Home", match: "home" },
  { route: "/movies", label: "Movies", match: "movies" },
  { route: "/shows", label: "TV Shows", match: "shows" },
  { route: "/live", label: "Live TV", match: "live" },
  { route: "/my-list", label: "My List", match: "my-list" },
];

export default function TopBar() {
  const navigate = useNavigate();
  const account = useAccount();
  // Solid background once the page scrolls so content never shows through
  // the header while reading it as "the header is scrolling away".
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <header className={`topbar${scrolled ? " scrolled" : ""}`}>
      <div className="topbar-inner">
        <NavLink to="/" className="wordmark" aria-label="PoKu home">
          PoKu
        </NavLink>
        <nav className="topnav" aria-label="Primary">
          {DESTINATIONS.map((d) => (
            <NavLink
              key={d.route}
              to={d.route}
              className={({ isActive }) => `nav-item${isActive ? " active" : ""}`}
            >
              {d.label}
            </NavLink>
          ))}
        </nav>
        <button
          className="search-icon"
          aria-label="Search"
          onClick={() => navigate("/search")}
        >
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round">
            <circle cx="10.5" cy="10.5" r="6" />
            <path d="M20 20l-5.2-5.2" />
          </svg>
        </button>
        {account ? (
          <div className="account-chip" title="Signed in — your progress and My List sync on this account">
            <span className="account-name">{account.username}</span>
            <button
              className="account-out"
              aria-label="Sign out"
              title="Sign out"
              onClick={async () => { await signOut(); navigate("/"); }}
            >
              ⎋
            </button>
          </div>
        ) : (
          <button className="account-in" aria-label="Sign in" onClick={() => navigate("/auth")}>
            Sign in
          </button>
        )}
      </div>
    </header>
  );
}